import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { AdvanceCategory, AdvanceType } from '../../events/CreateChargeEvent';
import { Checkbox, DateString, NonNegativeFloat, PositiveMonetaryValue } from '../fields';
import { InvestorSplit } from './RecordDrawDisbursementRow';

const baseShape = {
  loanId: LosId,
  interestRatePercent: NonNegativeFloat,
  advanceType: AdvanceType.optional(),
  payeeId: z.string().optional(),
  recipient: z.string().optional(),
  advanceDate: DateString,
  advancePrincipal: PositiveMonetaryValue,
  investorRemittanceSplit: InvestorSplit.optional(),
  isDeferred: Checkbox,
  isWaived: Checkbox,
  comment: z.string().optional(),
  advanceCategory: AdvanceCategory.optional(),
};

const baseObject = z.object(baseShape);

export const CreateAdvanceRow = baseObject.superRefine((row, ctx) => {
  if (!row.payeeId && !row.recipient) {
    ctx.addIssue({
      code: 'custom',
      path: ['recipient'],
      message: 'Either payeeId or recipient is required.',
    });
  }
});
export type CreateAdvanceRow = z.infer<typeof CreateAdvanceRow>;

export const CREATE_ADVANCE_ROW_REQUIRED_FIELDS = Object.keys(baseShape).filter(
  (key) => !baseShape[key as keyof typeof baseShape].isOptional(),
);
